const AEMBaseUrl = '/po/content';

/* to be used in a non react function */
const getAEMBaseUrl: (url: string) => string = (url) => {
    return `${AEMBaseUrl}${url}`;
};

export default getAEMBaseUrl;
